<template>
  <v-card class="ma-0 overflow-visible" outlined>
    <v-list-item class="pa-0" three-line>
      <v-list-item-content class="overflow-visible pa-0">
        <v-col cols="12" md="12" class="mx-auto">
          <v-row class="mx-2">
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filterForm.userIds"
                :items="users"
                label="Người tạo"
                color="primary"
                item-text="fullName"
                item-value="id"
                placeholder="Chọn người tạo"
                multiple
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
              <common-range-picker
                :clearable="true"
                :aLight="'right'"
                label="Ngày tạo"
                @change-date-range="changeDateRange"
              ></common-range-picker>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="filterForm.domain"
                :items="listDomain"
                placeholder="Chọn tên miền"
                label="Tên miền"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filterForm.originUrl"
                label="Link gốc"
                placeholder="Nhập Link gốc"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="mx-auto">
          <v-row class="mx-2">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filterForm.shortLink"
                label="Link rút gọn"
                placeholder="Nhập Link rút gọn"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filterForm.urlId"
                label="Đường dẫn"
                placeholder="Nhập đường dẫn"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="filterForm.typeClicks"
                :items="typeSearch"
                item-text="label"
                item-value="value"
                label="So sánh"
                eager
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filterForm.clicks"
                type="number"
                label="Số Lần click"
                placeholder="Nhập số lần"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <div class="d-flex text-center mb-4 justify-center">
          <v-btn class="primary mx-0" @click.prevent="handleSubmit()">
            Tìm kiếm <v-icon class="ml-2">mdi-magnify</v-icon>
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  props: {
    listDomain: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  data() {
    return {
      typeSearch: [
        {
          label: "Bằng",
          value: "eq",
        },
        {
          label: "Lớn hơn",
          value: "gt",
        },
        {
          label: "Nhỏ hơn",
          value: "lt",
        },
      ],
      filterForm: {
        userIds: null,
        createdAt: null,
        domain: null,
        urlId: null,
        shortLink: null,
        originUrl: null,
        typeClicks: "eq", // gt, lt
        clicks: null,
      },
    };
  },
  methods: {
    changeDateRange(dateRange) {
      if (dateRange.startDate === "" || dateRange.endDate === "") {
        this.filterForm.createdAt = null;
      } else {
        this.filterForm.createdAt = [dateRange.startDate, dateRange.endDate];
      }
    },
    handleSubmit() {
      if (this.filterForm.clicks === null) {
        this.filterForm.typeClicks = null;
      }
      if (this.filterForm.domain === "Tất cả") {
        this.filterForm.domain = null;
      }
      this.$emit("filterData", this.filterForm);
    },
  },
};
</script>